"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressSuggestions = void 0;
const react_1 = __importDefault(require("react"));
const base_suggestions_1 = require("./base-suggestions");
const highlight_words_1 = require("./highlight-words");
require("./types");
class AddressSuggestions extends base_suggestions_1.BaseSuggestions {
    constructor() {
        super(...arguments);
        this.loadSuggestionsUrl = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';
        this.getLoadSuggestionsData = () => {
            const { count, filterFromBound, filterToBound, filterLocations, filterLocationsBoost, filterLanguage, filterRestrictValue, } = this.props;
            const { query } = this.state;
            const requestPayload = {
                query,
                count: count || 10,
            };
            if (filterFromBound && filterToBound) {
                requestPayload.from_bound = { value: filterFromBound };
                requestPayload.to_bound = { value: filterToBound };
            }
            if (filterLanguage) {
                requestPayload.language = filterLanguage;
            }
            if (filterLocations) {
                requestPayload.locations = filterLocations;
            }
            if (filterLocationsBoost) {
                requestPayload.locations_boost = filterLocationsBoost;
            }
            if (filterRestrictValue) {
                requestPayload.restrict_value = true;
            }
            return requestPayload;
        };
        this.renderOption = (suggestion) => {
            const { renderOption, highlightClassName, setOption } = this.props;
            const { query } = this.state;
            return renderOption ? (renderOption(suggestion, query)) : (react_1.default.createElement(highlight_words_1.HighlightWords, { highlightClassName: highlightClassName || 'react-dadata--highlighted', words: this.getHighlightWords(), tagName: "mark", text: setOption ? setOption(suggestion) : suggestion.value }));
        };
    }
}
exports.AddressSuggestions = AddressSuggestions;
